var map = {
	"./adventurer.png": 46,
	"./bat_alpha.png": 47,
	"./bat_omega.png": 48,
	"./blue_bat_alpha.png": 49,
	"./blue_bat_omega.png": 50,
	"./blue_slime_alpha.png": 51,
	"./blue_slime_omega.png": 52,
	"./blue_snake.png": 53,
	"./char_bat.png": 39,
	"./char_bat2.png": 40,
	"./char_main.png": 32,
	"./char_slime.png": 37,
	"./char_slime2.png": 38,
	"./char_snake.png": 41,
	"./char_snake2.png": 42,
	"./collectible.png": 31,
	"./goal.png": 54,
	"./gravestone.png": 33,
	"./shrub.png": 34,
	"./slime_alpha.png": 55,
	"./slime_omega.png": 56,
	"./snake.png": 57,
	"./tiles/0.png": 58,
	"./tiles/1.png": 59,
	"./tiles/2.png": 60,
	"./tiles/brickwall.png": 61,
	"./tiles/brickwall_left.png": 62,
	"./tiles/brickwall_right.png": 63,
	"./tiles/dirt.png": 64,
	"./tiles/dirtborder_bottom.png": 65,
	"./tiles/dirtborder_bottomleft.png": 66,
	"./tiles/dirtborder_bottomleft_out.png": 67,
	"./tiles/dirtborder_bottomright.png": 68,
	"./tiles/dirtborder_bottomright_out.png": 69,
	"./tiles/dirtborder_left.png": 70,
	"./tiles/dirtborder_right.png": 71,
	"./tiles/dirtborder_top.png": 72,
	"./tiles/dirtborder_topleft.png": 73,
	"./tiles/dirtborder_topleft_out.png": 74,
	"./tiles/dirtborder_topright.png": 75,
	"./tiles/dirtborder_topright_out.png": 76,
	"./tiles/grass.png": 77,
	"./tiles/grassborder_bottom.png": 78,
	"./tiles/grassborder_bottomleft.png": 79,
	"./tiles/grassborder_bottomleft_out.png": 80,
	"./tiles/grassborder_bottomright.png": 81,
	"./tiles/grassborder_bottomright_out.png": 82,
	"./tiles/grassborder_left.png": 83,
	"./tiles/grassborder_right.png": 84,
	"./tiles/grassborder_top.png": 85,
	"./tiles/grassborder_topleft.png": 86,
	"./tiles/grassborder_topleft_out.png": 87,
	"./tiles/grassborder_topright.png": 88,
	"./tiles/grassborder_topright_out.png": 89,
	"./tiles/leaves_bunch1.png": 90,
	"./tiles/leaves_bunch2.png": 91,
	"./tiles/leaves_quad.png": 92,
	"./tiles/leaves_tri.png": 93,
	"./tiles/pedestal.png": 36,
	"./tiles/pedestal_nosword.png": 94,
	"./tiles/pedestal_swordonly.png": 95,
	"./tiles/pedestal_withsword.png": 35,
	"./tiles/rockplatform_bottom.png": 96,
	"./tiles/rockplatform_bottomleft.png": 97,
	"./tiles/rockplatform_bottomleft_in.png": 98,
	"./tiles/rockplatform_bottomright.png": 99,
	"./tiles/rockplatform_bottomright_in.png": 100,
	"./tiles/rockplatform_left.png": 101,
	"./tiles/rockplatform_right.png": 102,
	"./tiles/rockplatform_top.png": 103,
	"./tiles/rockplatform_topleft.png": 104,
	"./tiles/rockplatform_topleft_in.png": 105,
	"./tiles/rockplatform_topright.png": 106,
	"./tiles/rockplatform_topright_in.png": 107,
	"./tiles/rockwall.png": 108,
	"./tiles/rockwall_bottom.png": 109,
	"./tiles/rockwall_bottomleft.png": 110,
	"./tiles/rockwall_bottomright.png": 111,
	"./tiles/rockwall_left.png": 112,
	"./tiles/rockwall_right.png": 113,
	"./tiles/sand.png": 114,
	"./tiles/sea.png": 115,
	"./tiles/sea_coral.png": 116,
	"./tiles/sea_lilypads.png": 117,
	"./tiles/seashore_bottom.png": 118,
	"./tiles/seashore_bottomleft.png": 119,
	"./tiles/seashore_bottomleft_out.png": 120,
	"./tiles/seashore_bottomright.png": 121,
	"./tiles/seashore_bottomright_out.png": 122,
	"./tiles/seashore_left.png": 123,
	"./tiles/seashore_right.png": 124,
	"./tiles/seashore_top.png": 125,
	"./tiles/seashore_topleft.png": 126,
	"./tiles/seashore_topleft_out.png": 127,
	"./tiles/seashore_topright.png": 128,
	"./tiles/seashore_topright_out.png": 129,
	"./tiles/woodplanks.png": 130,
	"./tiles/woodplanks_left.png": 131,
	"./tiles/woodplanks_right.png": 132,
	"./ui/heart-full-white.png": 133,
	"./ui/heart-full-yellow.png": 134,
	"./ui/heart-half-white.png": 135,
	"./ui/heart-half-yellow.png": 136,
	"./ui/heart-none-white.png": 137,
	"./ui/heart-none-yellow.png": 138,
	"./ui/keyboard.png": 139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;